import { render, staticRenderFns } from "./adr-lookup.vue?vue&type=template&id=38a446c6&"
import script from "./adr-lookup.vue?vue&type=script&lang=ts&"
export * from "./adr-lookup.vue?vue&type=script&lang=ts&"
import style0 from "./adr-lookup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports